// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"iq-z","slideIn":"jq-z"};